<template>
<loader v-bind="{ loading }">
  <page-navigation title="New Audit">
    <template #right>
      <router-link class="button" :to="{
        name: 'audits'
      }">
        Audits
      </router-link>
    </template>
  </page-navigation>
  <message class="is-warning">
    Audits conducted against an environment are intended to shed light on the applications compliance level 
    for the respective standard. It is impossible to assess every checkpoint in a security standard via an 
    automated test. Some checkpoints require authenticated access with a human performing the tests.
    Snitch will audit every checkpoint that can be executed in an automated fashion.
  </message>
  <form>
    <div class="columns">
      <div class="column">
        <select-input
          required
          :items="availableEnvironments" 
          @input="updateEnv"
          value-key="id" 
          label-key="name" 
          :value="audit.environment_id"
          :error="$root.errorBag.environment_id"
          description="Only public facing environments can be audited">
          Environment
        </select-input>
      </div>
      <div class="column">
        <select-input
          required
          :items="standardsList" 
          @input="updateStandard"
          value-key="id" 
          label-key="name" 
          :value="audit.standard_id"
          :error="$root.errorBag.standard_id"
          description="Only public facing environments can be audited">
          Standard
        </select-input>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <submit-button :working="working" @submit="startAudit">Start Audit</submit-button>
      </div>
    </div>
  </form>
</loader>  
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  
  data: () => ({
    loading: true,
     working: false
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'New Audit')
  },

  created() {
    this.clearAudit()
    if(this.$route.params.app) {
      this.updateSite(this.$route.params.app)
      Promise.all([
        this.$store.dispatch('standard/loadStandardsList'),
        this.$store.dispatch('environment/loadPublicEnvList', this.$route.params.app),
      ]).then(() => {
        this.loading = false
      })
    }
  },
  
  destroyed() {
    this.clearAudit()
  },

  methods: {
    ...mapMutations('audit', [
      'updateSite',
      'updateEnv',
      'updateStandard',
      'clearAudit'
    ]),
    startAudit() {
      this.working = true
      this.$store.dispatch('audit/startAudit').then((auditId) => {
        this.working = false
        this.$toast.success('Audit Started Successfully')
        this.clearAudit()
        this.$router.back()
      }, error => {
        console.log(error)
        this.$toast.error('Could not start Audit.')
        this.working = false
      })
    }
  },

  computed: {
    ...mapGetters('audit', [
      'audit'
    ]),
    ...mapGetters('app', [
      'app'
    ]),
    ...mapGetters('environment', [
      'environmentsList'
    ]),
    ...mapGetters('standard', [
      'standardsList'
    ]),
    availableEnvironments() {
      return this.environmentsList.map((env) => {
        return {
          name: `${env.name} - ${env.public_url}`,
          id: env.id
        }
      })
    }
  }

}
</script>